const isDev = process.env.NODE_ENV === "development";
export const logConfig = {
  host: "ap-northeast-1.log.aliyuncs.com", // 所在地域的服务入口。
  project: "hwmaj-client", // Project名称。
  logstore: "flow-log", // Logstore名称。
  time: 10, // 发送日志的时间间隔，默认是10秒。
  count: 10, // 发送日志的数量大小，默认是10条。
  topic: isDev ? "dev" : "release", // 自定义日志主题。
};
